module.exports = __webpack_public_path__ + "static/img/24.0ae2854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/24.png
// module id = A+gA
// module chunks = 0